export default {
  bindings: {
    downloadUrl: '<',
  },

  controllerAs: 'vm',
  templateUrl: 'shared/templates/nv-video-preview-unavailable.html',
};
